import * as XLSX from 'xlsx';
import Parameters from '@/assets/js/parameters'
import shareds from '@/assets/js/shared';
const parameters = new Parameters()
const shared = new shareds()
class Inv {
    constructor(apiService = null) {
        this.obj_name = 'inv';
        this.apiService = apiService; // 將 ApiService 實例儲存為屬性
    }

    // 共用的 API 呼叫方法
    async callApi(method, endpoint, parameter = {}, progressEvent = null) {
        const apiConfig = {
            url: `${this.apiService.url}${this.obj_name}/${endpoint}`,
            parameter,
        };

        return new Promise((resolve) => {
            if (method === 'get') {
                apiConfig.url += `?${this.apiService.getMethodEncryp(parameter)}`;
                this.apiService.getApi({
                    url: apiConfig.url,
                    success: resolve,
                    error: (res) => {
                        this.apiService.debug('error:', res);
                        resolve(res);
                    },
                });
            } else if (method === 'post') {
                this.apiService.postFormDataApi({
                    url: apiConfig.url,
                    parameter: apiConfig.parameter,
                    success: resolve,
                    progress: (res) => {
                        this.apiService.debug(res);
                        if (progressEvent) {
                            progressEvent(res);
                        }
                    },
                    error: (res) => {
                        this.apiService.debug('error:', res);
                        resolve(res);
                    },
                });
            } else if (method === 'delete') {
                // DELETE 請求
                this.apiService.delApi({
                    url: apiConfig.url,
                    parameter: apiConfig.parameter,
                    success: resolve,
                    error: (res) => {
                        this.apiService.debug('error:', res);
                        resolve(res);
                    },
                });
            }
        });
    }

    // 表單檢查
    checkCreateInvFormModel(formData) {
        const validations = [
            { condition: formData.item_category === -1, message: '請選擇品項群組' },
            { condition: formData.item_type === -1, message: '請選擇品項類別' },
            { condition: formData.ERP_no.trim() === '', message: '請輸入ERP品號' },
            { condition: formData.item_name.trim() === '', message: '請輸入品項名稱' },
            { condition: formData.unit === -1, message: '請選擇單位' },
            { condition: formData.vendor === -1, message: '請選擇廠商' },
            {
                condition: formData.item_category === 3 && formData.is_controlledDrugs && formData.controlled_level === -1,
                message: '勾選為管制藥品時，請選擇管制藥品級別',
            },
            {
                condition: formData.item_category === 3 && formData.is_controlledDrugs && formData.license_no.trim() === '',
                message: '勾選為管制藥品時，藥品許可證字號不能是空的',
            },
        ];

        for (const { condition, message } of validations) {
            if (condition) {
                return { status: false, message };
            }
        }

        return { status: true };
    }
    // API 方法
    //庫存 | 101新增庫存品項
    async addItem(parameter, progressEvent = null) {
        return this.callApi('post', 'addItem', parameter, progressEvent);
    }
    //庫存 | 102更新庫存品項
    async updItem(parameter, progressEvent = null) {
        return this.callApi('post', 'updItem', parameter, progressEvent);
    }
    //庫存 | 103更新庫存品項異動
    async updItemStorage(parameter, progressEvent = null) {
        return this.callApi('post', 'updItemStorage', parameter, progressEvent);
    }
    //庫存 | 104取得品相詳細資料
    async getInventoryItemDetailByItemId(parameter) {
        return this.callApi('get', 'getInventoryItemDetailByItemId', parameter);
    }
    //庫存 | 105搜尋品相列表
    async getInventoryItemsByKeywordWithPage(parameter) {
        return this.callApi('get', 'getInventoryItemsByKeywordWithPage', parameter);
    }
    //庫存 | 106新增採購單
    async addPo(parameter, progressEvent = null) {
        return this.callApi('post', 'addPo', parameter, progressEvent);
    }
    //共用處理分類類型新增品項類型
    async saveItemType(group_type, formData) {
        this.apiService.debug('saveItemType:', formData);

        const objFrom = new FormData();
        objFrom.append('item_category', group_type);
        objFrom.append('item_type_name', formData.item_type_name.trim());
        objFrom.append('ERP_type_no', formData.ERP_type_no.trim());

        if (formData.id != null) {
            objFrom.append('item_type_id', formData.id);
            return this.updItemType(objFrom);
        }
        return this.addItemType(objFrom);
    }
    //庫存 | 107新增品項類型
    async addItemType(parameter, progressEvent = null) {
        return this.callApi('post', 'addItemType', parameter, progressEvent);
    }
    //庫存 | 108更新品項類型
    async updItemType(parameter, progressEvent = null) {
        return this.callApi('post', 'updItemType', parameter, progressEvent);
    }
    //庫存 | 110取得品相類型列表
    async getItemTypeByItemCategoryId(parameter) {
        return this.callApi('get', 'getItemTypeByItemCategoryId', parameter);
    }
    //庫存 | 112取得採購中列表
    async getPoProcessingByKeywordWithPage(parameter) {
        return this.callApi('get', 'getPoProcessingByKeywordWithPage', parameter);
    }
    //庫存 | 113取得採購完成列表
    async getPoInStockByKeywordWithPage(parameter) {
        return this.callApi('get', 'getPoInStockByKeywordWithPage', parameter);
    }
    //庫存 | 114採購單入庫
    async updPoItemsInvItemStoreByJson(parameter, progressEvent = null) {
        return this.callApi('post', 'updPoItemsInvItemStoreByJson', parameter, progressEvent);
    }
    //庫存 | 115取得採購詳細資料
    async getPoDetailByPoId(parameter) {
        return this.callApi('get', 'getPoDetailByPoId', parameter);
    }
    //庫存 | 116出庫(採購單入庫不可用)
    async updInvItemStoreByJson(parameter, progressEvent = null) {
        return this.callApi('post', 'updInvItemStoreByJson', parameter, progressEvent);
    }
    //庫存 | 117取得庫存歷程
    async getItemChangeHistoryByItemId(parameter) {
        return this.callApi('get', 'getItemChangeHistoryByItemId', parameter);
    }
    //庫存 | 118取得庫存歷程(分頁)
    async getItemChangeHistoryByItemIdByPage(parameter) {
        return this.callApi('get', 'getItemChangeHistoryByItemIdByPage', parameter);
    }
    //庫存 | 119取得品項清單
    async getInventoryItemsByCompanyIdItemCategoryItemType(parameter) {
        return this.callApi('get', 'getInventoryItemsByCompanyIdItemCategoryItemType', parameter);
    }
    //庫存 | 120搜尋庫存列表
    async getInventoryItemsStoreByKeywordWithPage(parameter) {
        return this.callApi('get', 'getInventoryItemsStoreByKeywordWithPage', parameter);
    }
    //嘗試停止，避免連續讀取
    async waitSleep(time){
        return new Promise((resolve, reject) => {
            setTimeout(()=>{
                resolve()
            },time)
        })
    }

    async exportAllControlledDrugsList(app){

        app.$store.state.progressStatue = true
        app.$store.state.progressValue = 0

        const res = await this.getInventoryItemsStoreByKeywordWithPage({
            item_category_id: 3,
            page_size: -1
        })

        if ( res.code !== 200 ){
            return alert(`[${res.code}]${res.msg}`)
        }
        const list = []
        for (let index = 0; index < res.data.list.length; index++) {
            const item = res.data.list[index];
            console.log(item)
            if ( item.is_controlledDrugs === 1){
                list.push(item)
            }
        }

        let worksheets = []
        const total = list.length
        
        //開始取得庫存歷程
        for (let index = 0; index < list.length; index++) {
            const element = list[index];
            const historyRes = await this.getItemChangeHistoryByItemId({
                item_id: element.id
            })
            if ( historyRes.code !== 200 ){
                return alert(`[${historyRes.code}]${historyRes.msg}`)
            }
            historyRes.data.sort((a, b) => new Date(b.create_time) - new Date(a.create_time));

            worksheets.push({
                drugs: element,
                worksheet: this.getWorkSheet(element ,historyRes.data)
            })

            app.$store.state.progressValue = (index+1 / list.length * 100).toFixed(0)

            await this.waitSleep(500)
        }

        console.log(`worksheets=` , worksheets)

        await this.createFullCustomExcel(worksheets)
        

    }

    //匯出管制藥
    async exportControlledDrugsList(itemID){
        //取得品項
        this.apiService.store.state.loadingStatus = true
        const itemRes = await this.getInventoryItemDetailByItemId({
            item_id: itemID
        })
        this.apiService.store.state.loadingStatus = false
        if ( itemRes.code !== 200 ){
            return false
        }
        console.log(itemRes.data)
        //取得庫存歷程
        this.apiService.store.state.loadingStatus = true
        const historyRes = await this.getItemChangeHistoryByItemId({
            item_id: itemID
        })
        this.apiService.store.state.loadingStatus = false
        if ( historyRes.code !== 200 ){
            return false
        }
        historyRes.data.sort((a, b) => new Date(b.create_time) - new Date(a.create_time));

        const worksheet = this.getWorkSheet(itemRes.data,historyRes.data)
        this.createCustomExcel(itemRes.data,worksheet)

    }
    getWorkSheet(drugs,history){
        const worksheet = {};
        let merges = []
        //標題
        worksheet['A1'] = { v: '管制藥品收支結存簿冊' };
        merges.push({ s: { r: 0, c: this.columnToIndex('A') }, e: { r: 0, c: this.columnToIndex('K') } })
        //藥品名稱
        worksheet['A2'] = { v: '藥品名稱' };
        worksheet['B2'] = { v: drugs.item_name };
        merges.push({ s: { r: 1, c: this.columnToIndex('B') }, e: { r: 1, c: this.columnToIndex('D') } })
        //管制藥品成分及含量
        worksheet['E2'] = { v: '管制藥品成分及含量' };
        merges.push({ s: { r: 1, c: this.columnToIndex('E') }, e: { r: 1, c: this.columnToIndex('F') } })
        worksheet['G2'] = { v: drugs.specification };
        merges.push({ s: { r: 1, c: this.columnToIndex('G') }, e: { r: 1, c: this.columnToIndex('I') } })
        //藥品許可證字號
        worksheet['J2'] = { v: '藥品許可證字號' };
        worksheet['K2'] = { v: drugs.license_no };
        //管制級別
        worksheet['A3'] = { v: '管制級別' };
        worksheet['B3'] = { v: `${drugs.controlled_level}級` };
        //製造廠名稱
        worksheet['C3'] = { v: '製造廠名稱' };
        worksheet['D3'] = { v: drugs.company_name };
        merges.push({ s: { r: 2, c: this.columnToIndex('D') }, e: { r: 2, c: this.columnToIndex('I') } })
        //最小單位
        worksheet['J3'] = { v: '最小單位' };
        worksheet['K3'] = { v: parameters.getGlobalUnitNameById(drugs.unit,'ch_name') };

        //測定庫存紀錄標題
        worksheet['A4'] = { v: '日期' };
        worksheet['B4'] = { v: '收支原因' };
        worksheet['C4'] = { v: '收入數量' };
        worksheet['D4'] = { v: '收入藥品批號' };
        merges.push({ s: { r: 3, c: this.columnToIndex('D') }, e: { r: 3, c: this.columnToIndex('E') } })
        worksheet['F4'] = { v: '支出數量' };
        merges.push({ s: { r: 3, c: this.columnToIndex('F') }, e: { r: 3, c: this.columnToIndex('G') } })
        worksheet['H4'] = { v: '結存數量' };
        worksheet['I4'] = { v: '備註' };
        merges.push({ s: { r: 3, c: this.columnToIndex('I') }, e: { r: 3, c: this.columnToIndex('K') } })
        
        //處理上期
        worksheet['A5'] = { v: '' };
        worksheet['B5'] = { v: '上期結存' };
        worksheet['D5'] = { v: '' }; //這裡加入批號
        merges.push({ s: { r: 4, c: this.columnToIndex('D') }, e: { r: 4, c: this.columnToIndex('E') } })
        merges.push({ s: { r: 4, c: this.columnToIndex('F') }, e: { r: 4, c: this.columnToIndex('G') } })
        worksheet['H5'] = { v: 0 };
        merges.push({ s: { r: 4, c: this.columnToIndex('I') }, e: { r: 4, c: this.columnToIndex('K') } })

        for (let index = 0; index < history.length; index++) {
            const el = history[index];
            const row = index+6
            worksheet[`A${row}`] = { v: shared.formatIosDate(el.create_time) }; //日期
            worksheet[`B${row}`] = { v: '' }; //收支原因
            worksheet[`C${row}`] = { v: el.storage_change_count > 0 ? el.storage_change_count : '' }; //收入數量
            worksheet[`D${row}`] = { v: '' }; //收入藥品批號
            merges.push({ s: { r: row-1, c: this.columnToIndex('D') }, e: { r: row-1, c: this.columnToIndex('E') } })
            worksheet[`F${row}`] = { v: el.storage_change_count < 0 ?  Math.abs(el.storage_change_count) : '' }; //支出數量
            merges.push({ s: { r: row-1, c: this.columnToIndex('F') }, e: { r: row-1, c: this.columnToIndex('G') } })
            worksheet[`H${row}`] = { v: el.storage_count }; //結存數量
            worksheet[`I${row}`] = { v: el.change_type }; //備註
            merges.push({ s: { r: row-1, c: this.columnToIndex('I') }, e: { r: row-1, c: this.columnToIndex('K') } })
        }

        worksheet['!merges'] = merges
        // 3. 定義工作表範圍
        worksheet['!ref'] = `A1:Q${history.length+10}`; // 定義有效範圍，從 A1 到 C3

        return worksheet
    }
    createFullCustomExcel(worksheets){
        // 4. 建立工作簿
        const workbook = XLSX.utils.book_new();
        // 過濾工作表名稱中的非法字元
        const sanitizeSheetName = (name) => name.replace(/[:\\\/\?\*\[\]]/g, '_');
        // 生成合法的工作表名稱
        for (let index = 0; index < worksheets.length; index++) {
            const drugs = worksheets[index].drugs;
            const worksheet = worksheets[index].worksheet;
            const sheetName = sanitizeSheetName(`${drugs.item_name}(${drugs.ERP_no})`);
            XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
        }
        
        // 下載檔案
        XLSX.writeFile(workbook, "管制藥品收支結存簿冊.xlsx");
    }

    createCustomExcel(drugs,worksheet){
        // 4. 建立工作簿
        const workbook = XLSX.utils.book_new();
        // 過濾工作表名稱中的非法字元
        const sanitizeSheetName = (name) => name.replace(/[:\\\/\?\*\[\]]/g, '_');
        // 生成合法的工作表名稱
        const sheetName = sanitizeSheetName(`${drugs.item_name}(${drugs.ERP_no})`);
        XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
        // 下載檔案
        XLSX.writeFile(workbook, "管制藥品收支結存簿冊.xlsx");
    }
    /**
     * 將 Excel 欄位字母 (如 A, ZZ) 轉換為數字索引值 (如 0, 701)
     * @param {string} columnName - 欄位名稱 (如 'A', 'ZZ')
     * @returns {number} - 對應的數字索引值 (0 開始)
     */
    columnToIndex(columnName) {
        let index = 0;
        for (let i = 0; i < columnName.length; i++) {
        index = index * 26 + (columnName.charCodeAt(i) - 'A'.charCodeAt(0) + 1);
        }
        return index - 1; // Excel 是 1-based，我們改為 0-based
    }
    
    /**
     * 將數字索引值 (如 0, 701) 轉換為 Excel 欄位字母 (如 A, ZZ)
     * @param {number} index - 數字索引值 (0 開始)
     * @returns {string} - 對應的欄位名稱
     */
    indexToColumn(index) {
        let columnName = '';
        while (index >= 0) {
        columnName = String.fromCharCode((index % 26) + 'A'.charCodeAt(0)) + columnName;
        index = Math.floor(index / 26) - 1;
        }
        return columnName;
    }
    /**
     * 計算單次劑量
     * 公式：(體重(kg) * 劑量標準(mg/kg)) / 藥品濃度(mg/ml) = 單次劑量(ml)
     * 注意：輸入的體重單位為公克(g)，計算時會除以 1000 轉換為公斤(kg)
     * 
     * @param {number} weight - 體重 (單位：公克 g)
     * @param {number} dosage - 物種劑量標準 (單位：mg/kg)
     * @param {number} volume - 藥品濃度 (單位：mg/ml)
     * @returns {number} 計算後的單次劑量 (單位：ml)
     */
    calculateSingleDose(weight, dosage, volume) {
        // 防呆保護：若濃度為 0 或無效，避免除以零錯誤，預設為 1
        const safeVolume = (volume && volume > 0) ? volume : 1;
        
        // 體重轉換：g -> kg
        const weightInKg = weight / 1000;
        
        // 計算公式
        const singleDose = (weightInKg * dosage) / safeVolume;
        
        return singleDose;
    }
}

export default Inv;
